import { liveValidatePattern } from '../validate/pattern';
import { liveValidateMaxLength } from '../validate/maxlength';
import { liveValidateMinLength } from '../validate/minlength';
import { liveValidateRequired } from '../validate/required';
import { liveValidateBlur } from '../validate/blur';
import { liveValidateEquals, validateEquals } from '../validate/equals';
import { liveValidateSubmit, validateSubmit, autoFocusFirstOnSubmitError } from '../validate/submit';

export default function validatePasswordRecoveryForm(element: string) {
    const form: HTMLFormElement | null = document.querySelector(element);

    if (form) {
        form.setAttribute('novalidate', 'novalidate');

        const inputs = [form.username, form.emailaddress, form.Password2, form.Password3].filter((item: HTMLInputElement) => {
            return item;
        });

        for (const el of inputs) {
            liveValidateMinLength(el);
            liveValidateMaxLength(el);
            liveValidatePattern(el);
            liveValidateBlur(el);
            liveValidateRequired(el);
        }

        if (form.Password2 && form.Password3) {
            liveValidateEquals(form.Password2, form.Password3);
        }

        liveValidateSubmit(form);

        form.addEventListener('submit', function (this: HTMLFormElement, e: Event) {
            const errors = [...validateSubmit(inputs), form.Password2 && form.Password3 && validateEquals(form.Password2, form.Password3)];

            const valid = errors.indexOf(false) === -1;

            if (!valid) {
                form.classList.add('focus-visible');
                autoFocusFirstOnSubmitError(this);

                e.preventDefault();

                return false;
            }
            return;
        });
    }
}
